import type { ChatListItem, ChatMessage } from '../types';

export const GUEST_CHATS_STORAGE_KEY = 'w-ai-guest-chats-v1';

export interface GuestChatSnapshot {
  version: 1;
  currentChatId: string | null;
  chats: ChatListItem[];
  transcripts: Array<[string, ChatMessage[]]>;
}

function isMessage(value: unknown): value is ChatMessage {
  if (!value || typeof value !== 'object') return false;
  const message = value as Partial<ChatMessage>;
  return typeof message.id === 'number' && typeof message.chatId === 'string' &&
    (message.role === 'user' || message.role === 'assistant') &&
    typeof message.content === 'string' && typeof message.createdAt === 'number';
}

export function loadGuestChats(): GuestChatSnapshot | null {
  try {
    const raw = window.localStorage.getItem(GUEST_CHATS_STORAGE_KEY);
    if (!raw) return null;
    const saved = JSON.parse(raw) as GuestChatSnapshot;
    if (saved.version !== 1 || !Array.isArray(saved.chats) || !Array.isArray(saved.transcripts)) return null;
    const transcripts = saved.transcripts.filter((entry) =>
      Array.isArray(entry) && typeof entry[0] === 'string' &&
      Array.isArray(entry[1]) && entry[1].every(isMessage)
    );
    const ids = new Set(transcripts.map(([id]) => id));
    return {
      version: 1,
      currentChatId: typeof saved.currentChatId === 'string' && ids.has(saved.currentChatId) ? saved.currentChatId : null,
      chats: saved.chats.filter((chat) => chat && ids.has(chat.chatId) && typeof chat.title === 'string'),
      transcripts,
    };
  } catch {
    return null;
  }
}

export function saveGuestChats(snapshot: GuestChatSnapshot): boolean {
  try {
    window.localStorage.setItem(GUEST_CHATS_STORAGE_KEY, JSON.stringify(snapshot));
    return true;
  } catch {
    return false;
  }
}
